import TabReportsComponent from './TabReports/TabReports'
import TabDashboardComponent from "./TabDashboard/TabDashboard";

export const TabReports = TabReportsComponent
export const TabDashboard = TabDashboardComponent
